'use client';

import type { ReactNode } from 'react';
import { UpdateSignalEditContentWrapper } from '../../HITL/wrappers/UpdateSignalEditContentWrapper';
import type { EditContentProps } from '../../tool-config-types';

export const renderUpdateSignalEditContent = (
  props: EditContentProps,
): ReactNode => (
  <UpdateSignalEditContentWrapper
    onClose={props.onClose}
    onSubmit={props.onSubmit}
    toolName={props.toolName}
    extractedData={props.extractedData}
  />
);
